import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams } from 'react-router-dom';
const ItemTransactionReport = () => {
  const [fromDate, setFromDate] = useState("2022-04-25");
  const [toDate, setToDate] = useState("2025-08-22");
  const [voucherType, setVoucherType] = useState("");
  const [particular, setParticular] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
 const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 

  console.log("id:",id);
  const fetchReport = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://www.nissi-india.com/api/item_transactionRpt`,
        {
          params: {
            item: id,
            branch: 8,
            store: "%",
            vouType: voucherType || "%",
            from: fromDate.split("-").reverse().join("/"),
            to: toDate.split("-").reverse().join("/"),
            particular: particular || "%"
          }
        }
      );
      setReportData(response.data.data || []);
      console.log("response:", response.data);
    } catch (err) {
      console.error("Error fetching report:", err);
    } finally {
      setLoading(false);
    }
  };

 

  return (
    <div className="p-6">
      {/* Filters */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium">From Date *</label>
          <input
            type="date"
            className="border p-2 rounded w-full"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium">To Date *</label>
          <input
            type="date"
            className="border p-2 rounded w-full"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Voucher Type</label>
          <select
            className="border p-2 rounded w-full"
            value={voucherType}
            onChange={(e) => setVoucherType(e.target.value)}
          >
            <option value="">Select</option>
            <option value="OP">Opening</option>
            <option value="INV">Invoice</option>
            <option value="GRN">GRN</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium">Particulars</label>
          <input
            type="text"
            className="border p-2 rounded w-full"
            value={particular}
            onChange={(e) => setParticular(e.target.value)}
          />
        </div>
      </div>

      <button
        className="bg-blue-600 text-white px-4 py-2 rounded mb-6"
        onClick={fetchReport}
      >
        View
      </button>

      {/* Report Table */}
      <div className="border rounded shadow overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-2 py-1">SNo</th>
              <th className="border px-2 py-1">Date</th>
              <th className="border px-2 py-1">Ref Number</th>
              <th className="border px-2 py-1">Particulars</th>
              <th className="border px-2 py-1">Voucher Type</th>
              <th className="border px-2 py-1">Inward Qty</th>
              <th className="border px-2 py-1">Inward Value</th>
              <th className="border px-2 py-1">Outward Qty</th>
              <th className="border px-2 py-1">Outward Value</th>
              <th className="border px-2 py-1">Closing Qty</th>
              <th className="border px-2 py-1">Total Amount</th>
              <th className="border px-2 py-1">Closing Value</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="12" className="text-center p-4">
                  Loading...
                </td>
              </tr>
            ) : reportData.length > 0 ? (
              reportData.map((row, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="border px-2 py-1">{idx + 1}</td>
                  <td className="border px-2 py-1">{row.fld_DocumentDate}</td>
                  <td className="border px-2 py-1">{row.Reference}</td>
                  <td className="border px-2 py-1">{row.Particulars}</td>
                  <td className="border px-2 py-1">{row.fld_documenttype}</td>
                  <td className="border px-2 py-1">{row.Received}</td>
                  <td className="border px-2 py-1">{row.ReceivedPrice}</td>
                  <td className="border px-2 py-1">{row.Issued}</td>
                  <td className="border px-2 py-1">{row.IssuePrice}</td>
                  <td className="border px-2 py-1">{row.fld_Closing_stock}</td>
                  <td className="border px-2 py-1">{row.totalclosingamount}</td>
                  <td className="border px-2 py-1">{row.ClosingValue}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center p-4">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemTransactionReport;
